import { CampaignInformationBlock } from '@urbanx/agx.support.client';
import { AgxColumn, AgxTypography } from '@urbanx/agx.ui-components2';
import PoisonQueueInformationTidbit from './PoisonQueueInformationTidbit';
import React from 'react';

const PoisonQueueCampaignInformation = ({
  campaignInformation,
}: {
  campaignInformation?: CampaignInformationBlock;
}) => {
  const { campaignId, address, vendors, contractInformation } = campaignInformation || {};

  if (!campaignInformation) return null;

  return (
    <AgxColumn gap="spacing-md">
      <AgxTypography id="campaign-information" type="heading" size="small">
        Campaign Information
      </AgxTypography>

      <PoisonQueueInformationTidbit label={'Campaign Id'} value={campaignId} />

      <PoisonQueueInformationTidbit label={'Address'} value={address} />

      <PoisonQueueInformationTidbit label={'Vendors'} value={vendors} />

      {contractInformation && contractInformation.length > 0 && (
        <>
          <AgxColumn gap="spacing-lg">
            <AgxTypography id={`poison-queue-information-contracts`} type={'label'} size={'small'}>
              Contracts
            </AgxTypography>

            {contractInformation?.map(({ contractId, salePrice, buyers }, idx) => {
              return (
                <React.Fragment key={idx}>
                  <PoisonQueueInformationTidbit label={'Contract Id'} value={contractId} />

                  <PoisonQueueInformationTidbit label={'Sale Price'} value={salePrice} />

                  <PoisonQueueInformationTidbit label={'Buyers'} value={buyers} />
                </React.Fragment>
              );
            })}
          </AgxColumn>
        </>
      )}
    </AgxColumn>
  );
};

export default PoisonQueueCampaignInformation;
